module.exports = __webpack_public_path__ + "static/GE_Module_2-2f3d10f5327e07d360fcd73c527a7cb5.png";